import { useState, useEffect } from "react";
import seriesStore from "../stores/seriesStore.js";
import statusStore from "../stores/statusStore.js";
import seasonStore from "../stores/seasonStore.js"
import episodeStore from "../stores/episodeStore.js";
import Header from "../components/Header.js";

export default function TestingPage() {
    const serStore = seriesStore();
    const staStore = statusStore();
    const seaStore = seasonStore();
    const epStore = episodeStore();

    const [selectedShow, setSelectedShow] = useState(null);
    const [selectedSeriesList, setSelectedSeriesList] = useState(null);

    const [activeHeader, setActiveHeader] = useState(false);
    
    const [searchText, setSearchText] = useState("");

    // Runs the function on load
    useEffect(() => {
        serStore.fetchSeries();
        staStore.fetchStatus();
        seaStore.fetchSeason();
        epStore.fetchEpisode();
    }, []);


    const populateDb = async () => {
        // Array of tv show names
        const arr = searchText.split(",").map(item => item.trim()).filter(Boolean);

        // Loop
        for (const item of arr) {

            // API search query to get most of the info
            const searchedShow = await serStore.tvdbSearchSeries(item);
            if (!searchedShow) return;

            if (searchedShow.primary_language != "eng") {
                console.log(item + " was not available in english.");
            } else {
                // Fill in that info in seriesForm
                serStore.populateForm1(searchedShow);

                // API specific query to get the rest of the info
                const searchedShow2 = await serStore.tvdbGetSeries(searchedShow.tvdb_id);
                if (!searchedShow2) return;

                // Fill in that info in seriesForm
                serStore.populateForm2(searchedShow2);
                //console.log(searchedShow2);

                // Check if already in db
                const existingShow = serStore.series.find(
                    s => String(s.tvdbId) === String(searchedShow.tvdb_id)
                );

                if (existingShow) {
                    console.log(searchedShow.name + " was already in the database.");

                    // Update it
                    serStore.updateSeries(existingShow._id);
                    
                    // Now lets add episodes
                    populateDbEpisodes(existingShow.tvdbId, existingShow._id, searchedShow.name);
                   
                } else {
                    const res = await serStore.createSeries();
                    //populateDbSeasons(res.data.series._id);
                    console.log("Added " + searchedShow.name);

                    // Now lets add episodes
                    populateDbEpisodes(res.data.series.tvdbId, res.data.series._id, searchedShow.name);
                }
                
            }
            
         };
    }



    const populateDbEpisodes = async (tvdbId, seriesId, showName) => {
        
        const res = await epStore.tvdbGetEpisodesBySeries(tvdbId); 
        const episodes = res.data.episodes;
                    
        for (const ep of episodes) {
            
            if (ep.seasonNumber == 0) {
            } else {
                // Check if it's already in the db
                const episodeExists = epStore.episode.some(existingEp =>
                    Number(existingEp.seasonNumber) === Number(ep.seasonNumber) &&
                    Number(existingEp.episodeNumber) === Number(ep.number) &&
                    String(existingEp.seriesId) === String(seriesId)
                );

                if (episodeExists) {
                    console.log(showName + " season " + ep.seasonNumber + ", episode " + ep.number + " was already in the db");
                }
                else {
                    // Fill in that info in episodeForm
                    epStore.populateEpisodeForm(ep, seriesId); // seriesId

                    // Add it to db                     
                    const res = await epStore.createEpisode();
                    console.log("Added " + showName + " season " + ep.seasonNumber + ", episode " + ep.number);
                }    
            }
        };
    }
        

    return (
        <div>
            <Header 
                selectedShow={selectedShow}
                setSelectedShow={setSelectedShow}
                selectedSeriesList={selectedSeriesList}
                setSelectedSeriesList={setSelectedSeriesList}
                activeHeader={activeHeader}
                setActiveHeader={setActiveHeader}/>
            <div>
                <div class="normalCSS">
                    <div className="adminBox1">  
                        <h4>Add show</h4> 
                        <p>Search for the following show:</p>
                         {<textarea
                            name="searchText"
                            placeholder="Enter text here..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        ></textarea>}
                        <br></br>
                        <button onClick={populateDb}>Add</button>
                    </div>
                   
                </div>
            </div>
      </div>
      )
}